import { getStore } from "../store/store";

export default function getUserSessionCount(): number {
    return getStore().userSessionCount ?? 0;
}
